<template>
	<div class="page machines">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 100"><path d="M44.4 10h-22a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-20-4h18V4h-18zm27 94h-36a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-34-4h32v-2h-32z"/><path d="M57.9 94H9.1a9 9 0 0 1-9-9.85l6.45-67.3A12 12 0 0 1 18.5 6H50a12 12 0 0 1 12 11.15l4.8 67.2a9 9 0 0 1-9 9.64zM18.5 10a8 8 0 0 0-8 7.24l-6.37 67.3a5 5 0 0 0 5 5.47H57.9a5 5 0 0 0 5-5.36l-4.8-67.2a8 8 0 0 0-8-7.43z"/><path d="M60.2 24.85A17 17 0 0 1 45.41 8h4a13 13 0 0 0 11.32 12.89zM61.1 35A27 27 0 0 1 35.41 8h4a23 23 0 0 0 21.88 23zm.8 10A37.13 37.13 0 0 1 25.41 8h4a33.12 33.12 0 0 0 32.53 33zm.74 10h-.2a47.06 47.06 0 0 1-47-46.94h4a43.06 43.06 0 0 0 43 42.94h.2zm-.2 10a57 57 0 0 1-56-46.14l3.93-.76a53 53 0 0 0 52 42.9h.86l.13 4zm0 10A67.27 67.27 0 0 1 4.56 41.81l3.45-2A63.25 63.25 0 0 0 62.41 71H64l.07 4z"/><path d="M4.53 63.86L4 60a12.9 12.9 0 0 0 10.11-7.3l3.6 1.72a16.88 16.88 0 0 1-13.19 9.54zM3.4 74l-.14-4A22.92 22.92 0 0 0 22 59.12l3.4 2.1A26.91 26.91 0 0 1 3.39 74zM2.4 84v-4a32.84 32.84 0 0 0 28-15.55l3.4 2.12A36.82 36.82 0 0 1 2.41 84zm5.05 9.73l-.42-4a43.14 43.14 0 0 0 32.61-21.22l3.46 2A47.15 47.15 0 0 1 7.46 93.73zm27.72-.1l-2.3-3.27A53.26 53.26 0 0 0 49.6 71.16L53.16 73a57.27 57.27 0 0 1-17.98 20.64zm26.55-25.06v-.01h4l-4 .01zm-11 24.8l-2.88-2.77a62.57 62.57 0 0 0 12.31-18.43l3.67 1.6a66.55 66.55 0 0 1-13.1 19.6z"/></svg>
					<span class="navigation-title">{{yarn.data.yarnName}}</span>
					<div class="navigation-right">
						<DotMenu alignment="right">
							<DotMenuItem @clicked="modify">{{$t('modify')}}</DotMenuItem>
							<DotMenuSeparator/>
							<DotMenuItem @clicked="print">{{$t('print')}}</DotMenuItem>
							<DotMenuSeparator/>
							<DotMenuItem @clicked="remove" class="delete">{{$t('delete')}}</DotMenuItem>
						</DotMenu>
					</div>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<form action="">
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="">{{$t('yarn-type')}}</label>
									<div class="element">
										<div class="flex">
											<input type="text" :value="$t($yarnUtils.selectType(yarn.data.yarnType).name)" readonly>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field" v-if="showNeedlesNumber">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="">{{$t('needles-number')}}</label>
									<div class="element">
										<div class="flex">
											<input type="text" :value="$utils.sanitize(yarn.data.needlesNumber)" readonly>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="">{{$t('composition')}}</label>
									<div class="element">
										<div class="flex">
											<div v-if="showCores" class="result-group">
												<input
													v-for="(core, index) in yarn.data.cores"
													:key="'core-' + index"
													type="text" :value="$t('core') + ' ' + coreLabel(core)" readonly>
											</div>
											<template v-else>
												<div class="result-group">
													<input
														v-for="(core, index) in yarn.data.coresA"
														:key="'core-' + index"
														type="text" :value="$t('cores-a') + ' ' + coreLabel(core)" readonly>
												</div>
												<div class="result-group">
													<input
														v-for="(core, index) in yarn.data.coresB"
														:key="'core-' + index"
														type="text" :value="$t('cores-b') + ' ' + coreLabel(core)" readonly>
												</div>
											</template>
											<div class="result-group">
												<input
													v-for="(covering, index) in yarn.data.coverings"
													:key="'covering-' + index"
													type="text" :value="coveringLabel(covering)" readonly>
											</div>
											<div class="result-group">
												<input
													v-for="(effect, index) in yarn.data.effects"
													:key="'effect-' + index"
													type="text" :value="effectLabel(effect)" readonly>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="">{{$t('steps')}}</label>
									<div class="element scroll-x" v-touch:swipe="notSwipe">
										<table id="steps" class="grid">
											<thead>
												<tr>
													<td>{{$t('number')}}</td>
													<td>{{$t('step-length-?')}}</td>
													<td>{{yarn.data.feedingLabel}}</td>
													<td v-if="showNeedlesNumber">{{$t('production-speed-?')}}</td>
													<td :key="'draft-'+index" v-for="(draft, index) in yarn.data.steps[0].drafts">{{$t('draft')}} {{index + 1}}</td>
													<!-- <td>{{$t('draft')}}</td>
													<td v-if="isColumnVisible(1)">{{$t('draft')}}</td>
													<td v-if="isColumnVisible(2)">{{$t('draft')}}</td> -->
												</tr>
											</thead>
											<tbody>
												<tr
													v-for="(step, index) in yarn.data.steps"
													:key="'step-'+index"
												>
													<td>{{$utils.sanitize(step.number)}}</td>
													<td>{{$utils.sanitize(step.length)}}</td>
													<td>{{$utils.sanitize(step.feeding)}}</td>
													<td v-if="showNeedlesNumber">{{$utils.sanitize(step.productionSpeed || 1)}}</td>
													<td :key="'draft-'+index" v-for="(draft, index) in step.drafts ">{{$utils.sanitize(draft)}}</td>
													<!-- <td>{{$utils.sanitize(step.drafts[0])}}</td>
													<td>{{step.drafts.map((draft) => $utils.sanitize(draft)).join(', ')}}</td>
													<td>{{step.drafts[1] ? $utils.sanitize(step.drafts[1]) : ''}}</td>
													<td>{{step.drafts[2] ? $utils.sanitize(step.drafts[2]) : ''}}</td> -->
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="">{{$t('final-yarn-count')}}</label>
									<div class="element">
										<YarnCountTable :units.sync="yarn.result.units" :selected="$settings.data.defaultYarnCount"/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
				<!--<hr>
				<div class="container">
					<div class="content">
						<button @click="remove">{{$t('delete')}}</button>
						<br><br>
						<button @click="print" class="">{{$t('print')}}</button>
					</div>
				</div>-->
			</section>
		</transition>
	</div>
</template>

<script>
import YarnCountTable from '@/components/YarnCountTable.vue'
import DotMenu from '@/components/DotMenu/DotMenu.vue'
import DotMenuItem from '@/components/DotMenu/DotMenuItem.vue'
import DotMenuSeparator from '@/components/DotMenu/DotMenuSeparator.vue'

const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
	data() {
		let yarn = this.$store.getters.getYarnsArchive.find(o => (o.id === parseInt(this.$route.params.id) && o.saved === this.$route.params.type));
		if (!yarn) {
			this.$router.go(-1);
		}

		return {
			yarn: yarn
		}
	},
	components: {
		YarnCountTable,
		DotMenu,
		DotMenuItem,
		DotMenuSeparator,
	},
	computed: {
		showCores() {
			let rst = true;
			if(this.yarn.data.workingPositions == 2) rst = false;
			return rst;
		},
		showNeedlesNumber() {
			let rst = false;
			switch (this.yarn.data.yarnType) {
				case 'fancy-yarn':
					rst = false;
					break;
				case 'ribbon-yarn':
					rst = true;
					break;
				case 'soft-knit-yarn':
					rst = true;
					break;
			}
			return rst;
		}
	},
	methods: {
		coreLabel(field) {
			return this.$utils.sanitize(field.yarnCount.value) + ' ' + this.$t(field.yarnCount.name) + ' = ' + this.percentage(field.result.percentage);
		},
		coveringLabel(field) {
			return this.$t('covering') + ' ' + this.$utils.sanitize(field.yarnCount.value) + ' ' + this.$t(field.yarnCount.name) + ' = ' + this.percentage(field.result.percentage);
		},
		effectLabel(field) {
			let rst = '';
			rst += this.$t('effect');

			switch (this.yarn.data.effectType) {
				case 'roving':
					rst += ' ' + this.$utils.sanitize(field.weight) + ' ' + this.$t('gr');
					break;
				case 'yarn':
					rst += ' ' + this.$utils.sanitize(field.yarnCount.value) + ' ' + this.$t(field.yarnCount.name);
					break;
			}
			rst += ' = ' + this.percentage(field.result.percentage);
			return rst;
		},
		percentage(value) {
			return (value * 100).toFixed(3) + '%';
		},
		modify() {
			this.$router.push({name: 'yarn-creation', params: {initialData: this.yarn.data}})
		},
		print() {
			let self = this;
			let body = [];
			let makeCoresTable = () => {
				if(self.yarn.data.workingPositions == 2){
					self.yarn.data.coresA.map((field) => {
						let dataRow = [];
						dataRow.push(this.$t('cores-a') + ' ' + self.coreLabel(field));
						body.push(dataRow);
					});
					self.yarn.data.coresB.map((field) => {
						let dataRow = [];
						dataRow.push(this.$t('cores-b') + ' ' + self.coreLabel(field));
						body.push(dataRow);
					});
				} else {
					self.yarn.data.cores.map((field) => {
						let dataRow = [];
						dataRow.push(this.$t('core') + ' ' + self.coreLabel(field));
						body.push(dataRow);
					});
				}
				return body;
			}

			let makeCoveringsTable = () => {
				let body = [];
				self.yarn.data.coverings.map((field) => {
					let dataRow = [];
						dataRow.push(self.coveringLabel(field));
					body.push(dataRow);
				});
				return body;
			}

			let makeEffectsTable = () => {
				let body = [];
				self.yarn.data.effects.map((field) => {
					let dataRow = [];
						dataRow.push(self.effectLabel(field));
					body.push(dataRow);
				});
				return body;
			}

			let makeStepsTable = () => {
				let body = [];
				const tableHead = [self.$t('number'), self.$t('step-length-?'), self.yarn.data.feedingLabel];
				if(this.showNeedlesNumber) tableHead.push(self.$t('production-speed-?'));
				self.yarn.data.steps[0].drafts.forEach( (draft, index) => {
					tableHead.push(self.$t('draft')  + ' ' + (index + 1));
				})

				body.push(tableHead);

				self.yarn.data.steps.map((step) => {
					let dataRow = [];
					dataRow.push(self.$utils.sanitize(step.number));
					dataRow.push(self.$utils.sanitize(step.length));
					dataRow.push(self.$utils.sanitize(step.feeding));
					if(this.showNeedlesNumber) dataRow.push(self.$utils.sanitize(step.productionSpeed || 1));
					step.drafts.forEach(draft => {
						dataRow.push(self.$utils.sanitize(draft));
					})
					//dataRow.push(step.drafts.map((draft) => self.$utils.sanitize(draft)).join(', '));
					body.push(dataRow);
				});
				return body;
			}

			let getTableWidth = () => {
				const table = makeStepsTable();
				const drafts = self.yarn.data.steps[0].drafts;
				const width = table[0].length - 1 - drafts.length;
				const widths = [];
				widths.push(45);
				for(let i = 0; i < width; i++){
					widths.push('*');
				}
				for(let i = 0; i < drafts.length; i++) {
					widths.push(45);
				}
				return widths;
			}

			let makeYarnCountsTable = () => {
				let body = [];

				self.yarn.result.units.map((unit) => {
					let dataRow = [];
					dataRow.push(self.$t(unit.name));
					dataRow.push(unit.value.toPrecision(5));
					dataRow.push(self.$t(unit.description));
					body.push(dataRow);
				});
				return body;
			}


			let headerSection = [{text: self.yarn.data.yarnName, style: 'header'}];
			let yarnTypeSection = [
				{text: self.$t('yarn-type'), style: 'subheader'},
				{
					style: 'table',
					table: {
						widths: ['*'],
						body: [
							[self.$t(self.$yarnUtils.selectType(self.yarn.data.yarnType).name)],
						],
					},
				},
			];
			let needleNumberSection = [
				{text: self.$t('needles-number'), style: 'subheader'},
				{
					style: 'table',
					table: {
						widths: ['*'],
						body: [
							[self.$utils.sanitize(self.yarn.data.needlesNumber)],
						],
					},
				},
			];
			let compositionSection = [
				{text: self.$t('composition'), style: 'subheader'},
				{
					style: 'table',
					table: {
						widths: ['*'],
						body: makeCoresTable(),
					},
				},
				{
					style: 'table',
					table: {
						widths: ['*'],
						body: makeCoveringsTable(),
					},
				},
				{
					style: 'table',
					table: {
						widths: ['*'],
						body: makeEffectsTable(),
					},
				},
			];
			let stepsSection = [
				{text: self.$t('steps'), style: 'subheader'},
				{
					style: 'table',
					table: {
						widths: getTableWidth(),
						headerRows: 1,
						body: makeStepsTable(),
					},
				},
				{text: self.$t('final-yarn-count'), style: 'subheader'},
				{
					style: 'table',
					table: {
						widths: ['*','auto','*'],
						body: makeYarnCountsTable(),
					},
				},
			];
			let content = [];
			content = content.concat(headerSection);
			content = content.concat(yarnTypeSection);
			if (self.showNeedlesNumber) content = content.concat(needleNumberSection);
			content = content.concat(compositionSection);
			content = content.concat(stepsSection);

			let docDefinition = {
				pageMargins: [40, 60, 40, 40],
				header: {
					stack: [
						{
							image: 'logo',
							width: 128,
							alignment: 'center',
							//margin: [40, 20, 40, 40],
						}
					], margin: [0, 20, 0, 0]
				},
				footer: function(currentPage, pageCount) {
					return {text: self.$t('generated-by-yarn-g-lab'), alignment: 'center'};
				},
				content: content,
				styles: {
					header: {
						fontSize: 18,
						bold: true,
						margin: [0, 0, 0, 8],
					},
					subheader: {
						fontSize: 16,
						bold: true,
						margin: [0, 8, 0, 4],
					},
					table: {
						margin: [0, 4, 0, 8],
					},
					tableHeader: {
						bold: true,
						fontSize: 13,
						color: 'black',
					},
				},
				defaultStyle: {
					// alignment: 'justify'
				},
				images: {
					logo: 'data:image/png;base64,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'
				}
			};

			let download = () => {
				let fileName = `${self.yarn.data.yarnName}.pdf`;

				pdfMake.createPdf(docDefinition).getBlob((blob) => {
					if (!window.isCordovaApp) {
						window.downloadFile(blob, fileName);
					} else {
						let dirName = window.cordova.file.dataDirectory;

						window.writeFile(blob, dirName, fileName)
						.then((fileEntry, type) => {
							return window.openFile(fileEntry, blob.type);
						})
						.then(() => {

						})
						.catch((err) => {
							console.log(err);
							self.$snack.danger({button: null, text: self.$i18n.t('create-file-error')});
						});
					}
				});
			}

			download();
		},
		remove() {
			let self = this;
			let onConfirm = (buttonIndex) => {
				if (buttonIndex == 1) {
					let id = self.yarn.id;
					switch(self.yarn.saved){
						case 'local':{
							self.$storage.getItem('yarns-archive').then((result) => {
								let yarnsArchive = [];
								if (result) yarnsArchive = result;

								yarnsArchive = yarnsArchive.filter(o => o.id !== id);

								return self.$storage.setItem('yarns-archive', yarnsArchive);
							}).then(() => {
								this.$snack.success({
									button: null,
									text: this.$i18n.tc('yarn-deleted-successfully', 1)
								});
								self.$router.go(-1);
								self.$store.dispatch('updateYarnsArchive');
							})
							.catch(error => {
								this.$snack.danger({
									button: null,
									text: this.$i18n.t('yarn-delete-error')
								});
							});
							break;
						}
						case 'cloud':{
							axios.delete(`/yarns/${id}`)
								.then(() => {
									this.$snack.success({
										button: null,
										text: this.$i18n.tc('yarn-deleted-successfully', 1)
									});
									self.$router.go(-1);
									self.$store.dispatch('updateYarnsArchive');
								})
								.catch(() => {
									this.$snack.danger({
										button: null,
										text: this.$i18n.t('yarn-delete-error')
									});
								})
							break;
						}
					}
				}
			}
			let message = self.$tc('delete-yarn-confirm', 1, {count: 1});
			if (navigator.notification) {
				navigator.notification.confirm(
					message,	// message
					onConfirm,						// callback to invoke with index of button pressed
					this.$t('delete-yarn'),			// title
					[this.$t('confirm'),
					this.$t('cancel')]	// buttonLabels
				);
			} else {
				if (confirm(message)) onConfirm(1);
			}
		},
		notSwipe(_, e) {
			e.stopPropagation();
		},
	}
}
</script>

<style scoped>
.result-group + .result-group {
	margin-top: .8rem;
}

.result-group > input + input {
	border-top: none;
}
</style>